import request from '@/utils/request'
import {
    encrypt
} from '@/utils/jsencrypt'

// 获取验证码
export function getCodeImg() {
    return request({
        url: '/code',
        method: 'get'
    })
}

// 登录方法
// export function login(username, password, code, uuid) {
//     password = encrypt(password)
//     const data = {
//         username,
//         password,
//         code,
//         uuid
//     }
//     return request({
//         url: '/auth/login',
//         method: 'post',
//         data: data
//     })
// }

// // 获取用户详细信息
// export function getInfo() {
//     return request({
//         url: '/system/user/getInfo',
//         method: 'get'
//     })
// }

export function loginPhoneCode(query) {
    return request({
        url: '/oauth/server-exam/registeredClient/phoneCode',
        method: 'get',
        params: query
    })
}


//跳转第三方应用 获取code
export function clientAutoLoginCode(params) {
    return request({
        url: '/oauth/server-exam/registeredClient/menHuCode',
        method: 'get',
        params: params
    })
}

/**选择角色后重新登录三步走 start*/
//获取code
export function redoClientCode(data) {
    return request({
        url: '/oauth/server-exam/registeredClient/code3',
        method: 'post',
        data: data,
    })
}

// 选择角色登录，直接换取凭证
export function refreshTokenByRelogin(data) {
    return request({
        url: '/oauth/server-exam/registeredClient/refreshTokenByRelogin',
        method: 'post',
        data: data
    })
}

/**登录三步走 start*/
//获取code
export function registeredClientCode(params) {
    return request({
        url: '/oauth/server-exam/registeredClient/code',
        method: 'get',
        params: params
    })
}
//根据codeValue获取到用户的accessToken与freshToken
export function getAccessTokenByCodeValue(data) {
    return request({
        url: '/oauth/server-exam/authorization/gettoken',
        method: 'post',
        data: data
    })
}
// 获取用户详细信息
export function getInfoByAnthor(data) {
    return request({
        url: '/oauth/server-exam/authorization/checktoken',
        method: 'post',
        data: data
    })
}
// 根据手机号获取登录用户列表
export function getUsersByTel(params) {
    return request({
        url: '/oauth/server-audit/userAudit/getUserInfoByTel',
        method: 'get',
        params: params
    })
}
// 切换账号
export function changeUser(data) {
    return request({
        url: '/oauth/server-exam/authorization/getTokenByUserNameAndPhoneNumber',
        method: 'post',
        data: data
    })
}
/**登录三步走 end*/
// 退出方法
export function logout() {
    return request({
        url: '/auth/logout',
        method: 'delete'
    })
}

// 获取验证码
// export function getCodeImg() {
//     return request({
//         url: '/code',
//         method: 'get'
//     })
// }

// 刷新方法
export function refreshToken() {
    return request({
        url: '/auth/refresh',
        method: 'post'
    })
}

// 获取用户列表
export function userList(params) {
    return request({
        url: '/oauth/server-exam/registeredClient/Userlist',
        method: 'get',
        params: params
    })
}
// 获取用户列表
export function automatically(data) {
    return request({
        url: '/oauth/server-exam/registeredClient/automatically',
        method: 'post',
        data: data
    })
}
export function associations(data) {
    return request({
        url: '/oauth/server-exam/registeredClient/associations',
        method: 'post',
        data: data
    })
}


// 根据不同登录类型获取code并跳转地址
export function getCodeUrl(query) {
    return request({
        url: '/oauth/server-exam/registeredClient/code',
        method: 'get',
        params: query,
        // baseUrl:'/dev-api-new'
    })
}





//获取手机验证码
export function getPhoneCode(query) {
    return request({
        url: '/oauth/server-exam/registeredClient/phoneCode',
        method: 'get',
        params: query,

    })
}

export function getCodeByToken(data) {
    return request({
        url: '/oauth/server-exam/authorization/getCodeByToken',
        method: 'post',
        data: data
    })
}

export function sendAppUsedRecord(clientId) {
    return request({
        url: `/oauth/chart/client/record/${clientId}`,
        method: 'put'
    })
}